import React from 'react';
import Posts from '../post/Posts';

const Home = () => (

    <div>
        <div className="jumbotron">
            <h2>Home</h2>
            <p className="lead">Welcome to the React Posts Application</p>
            <p>This was developed using Mongo DB, Express, React and Node.</p>
        </div>
        <div className="container">
            <Posts />
        </div>
    </div>
);

export default Home;